import ModalContext from './modal-context';


class IntlSelectorContext extends ModalContext {}


export default IntlSelectorContext;
